'use strict';
const React = require('react');
const AutoCompleteLink = require('./AutoCompleteLink');
const classnames = require('classnames');
const { connect } = require('react-redux');
const { autoCompleteSelector } = require('../../../selectors');

const AutoCompleteButton = (props) => {
	const {item, selected, ...other} = props;
	return (
		<li className="svtse_auto-complete-list__list-btn-item" {...other}>
			<AutoCompleteLink isSelected={selected} button={true} tabIndex="-1" target={item.target} icon={['search','before',false]}>
				<span>Sök </span><span className="svtse_auto-complete-list__btn-text-ellipsis">{item.searchTerm}</span><span className="svtse_auto-complete-list__btn-text-trailing"> på hela SVT</span>
			</AutoCompleteLink>
		</li>
	);
};

const AutoCompleteSuggestion = (props) => {
	const {item, selected, ...other} = props;
	const className = classnames({
		'svtse_auto-complete-list__list-item-link': true,
		'svtse_auto-complete-list__list-item-link--selected': selected
	});

	return (
		<li className="svtse_auto-complete-list__list-item" {...other}>
			<AutoCompleteLink target={item.url} tabIndex="-1" className={className}>{item.title}</AutoCompleteLink>
		</li>
	);
};


class AutoCompleteList extends React.Component {
	render() {
		const model = this.props.model;
		// TODO: should be considered active in small if something is written in the box...
		if (!model.get('show', false)) {
			return (<noscript/>);
		}
		const suggestions = model.get('suggestions', { toJS: () => [] }).toJS();
		return (
			<div className="svtse_auto-complete-list">
				<ul className="svtse_auto-complete-list__list">
				{suggestions.map(function (item, index) {
					const selected = index === model.get('index');
					if (item.searchLink) {
						return (<AutoCompleteButton item={item} selected={selected} key={index} />);
					} else {
						return (<AutoCompleteSuggestion item={item} selected={selected} key={index} />);
					}
				})}
				</ul>
			</div>
		);
	}
}
	
AutoCompleteList.contextTypes = {
	store: React.PropTypes.object.isRequired
};


function select(state) {
	return {
		model: autoCompleteSelector(state) 
	};
}

export default connect(select)(AutoCompleteList);



/** WEBPACK FOOTER **
 ** ./app/components/menu/search/AutoCompleteList.jsx
 **/